import {
  AttendanceCompensationsDocument,
  AttendanceCompensationsQuery,
  AttendanceCompensationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type AttendanceCompensationsType =
  AttendanceCompensationsQuery['attendance']['compensations']
export type AttendanceCompensationType =
  AttendanceCompensationsQuery['attendance']['compensations'][0]

export const useFetchCompensations = (
  variables: AttendanceCompensationsQueryVariables,
  skipFetch: { skip: boolean } = { skip: false }
) => {
  const { loading, data, refetch } = useQuery(AttendanceCompensationsDocument, {
    variables,
    skip: skipFetch?.skip,
    fetchPolicy: 'cache-first',
  })

  const compensations = new CompensationCollection(data?.attendance.compensations ?? [])

  return {
    loading,
    compensations,
    refetch,
  }
}

export class CompensationCollection {
  compensations: AttendanceCompensationsType

  constructor(compensations: AttendanceCompensationsType) {
    this.compensations = compensations
  }

  forCategory({
    id,
    rawMinutes,
    equivalentMinutes,
  }: {
    id: number | null | undefined
    rawMinutes: number
    equivalentMinutes: number
  }) {
    const compensationsForId = this.compensations.filter(
      (compensation) =>
        compensation.timeSettingsCustomTimeRangeCategoryId === id &&
        compensation.rawMinutesInCents / 100 === rawMinutes &&
        compensation.equivalentMinutesInCents / 100 === equivalentMinutes
    )
    return new CompensationCollection(compensationsForId)
  }

  get totalMinutes() {
    return this.compensations.reduce((total, compensation) => total + compensation.minutes, 0)
  }
}
